import { Task } from '@/models/task.model';

export interface TaskState {
  opportunityTasks: Task[]; // Tasks for the currently viewed opportunity
  currentTask: Task | null; // Task being viewed/edited
  loading: boolean;
  error: any;
}

export const initialState: TaskState = {
  opportunityTasks: [],
  currentTask: null,
  loading: false,
  error: null,
};
